import { Middleware } from 'redux'
import { messageActions } from './messageSlice';
import MessageEvent from './messageEvent';
import Message from "./message";
import CookieHelper from "helpers/cookie";
 import {logoutUser}  from "@/reducers/Authorisation";
 import { notificationActions } from '@/reducers/Notification';
 
const messageMiddleware: Middleware = store => {

    const sendMessage= ((action) => {
	
	});
  
  
	return next => action => {
		next(action);
    }
    
}
 
export default messageMiddleware;